import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { SettingsIcon } from 'shared/components/Icons';

import s from './ShowFilterButtonLine.css';

class ShowFilterButtonLine extends React.Component {
  static propTypes = {
    handleClick: PropTypes.func.isRequired,
    collapsed: PropTypes.bool.isRequired,
  };

  render() {
    const { collapsed, handleClick } = this.props;
    const text = collapsed ? 'Все фильтры' : 'Скрыть фильтры';
    return (
      <div className={s.root} onClick={handleClick}>
        <div className={s.text}>
          {text}
        </div>
        <div
          className={cx(s.icon, {
            [s.iconYellow]: collapsed,
          })}
        >
          <SettingsIcon />
        </div>
        {!collapsed && <div className={s.line} />}
      </div>
    );
  }
}

export default withStyles(s)(ShowFilterButtonLine);



// WEBPACK FOOTER //
// ./src/desktop/components/SearchPanelV2/ShowFilterButtonLine/ShowFilterButtonLine.js